export const AddressItem = class extends HTMLElement {
  form?: HTMLElement | null;
  addressId?: string; // use "new" as an id for new addresses, address Id can be omitted as well for this
  addressesUrl?: string;

  constructor() {
    super();
    this.toggleOpen = this.toggleOpen.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  connectedCallback() {
    this.form = this.querySelector("custom-form");
    this.addressId = this.getAttribute("data-address-id") || "new";
    this.addressesUrl = this.getAttribute("data-addresses-url") || "";

    if (this.hideIfDeleted()) return;

    if (this.isNewAddress()) document.querySelector("[data-address-new-toggle]")?.addEventListener("click", this.toggleOpen);

    this.querySelectorAll("[data-toggle-form]").forEach((form) => form.addEventListener("click", this.toggleOpen));
    this.querySelectorAll("[data-delete-address]").forEach((form) => form.addEventListener("click", this.handleRemove));
    this.createCountryProvince();
  }

  disconnectedCallback() {
    if (this.isNewAddress()) document.querySelector("[data-address-new-toggle]")?.removeEventListener("click", this.toggleOpen);
    
    this.querySelectorAll("[data-toggle-form]").forEach((form) => form.removeEventListener("click", this.toggleOpen));
    this.querySelectorAll("[data-delete-address]").forEach((form) => form.removeEventListener("click", this.handleRemove));
  }

  // quick workaround for persisting deleted address state
  hideIfDeleted() {
    if (localStorage.getItem(`removed_address:${this.addressId}`) === "true") {
      localStorage.removeItem(`removed_address:${this.addressId}`);
      this.classList.add("hidden");
      return true
    }
  }

  isNewAddress() {
    return this.addressId === "new"
  }

  getToggleButtons() {
    return this.isNewAddress() ? document.querySelectorAll("[data-address-new-toggle]") : this.querySelectorAll("[data-toggle-form]");
  }

  createCountryProvince() {
    const country = this.querySelector("[data-address-country]");
    const province = this.querySelector("[data-address-province]");
    const container = this.querySelector("[data-country-container]");

    if (!country || !province || !container) throw Error("Country and province containers must be provided");

    country.id = `address_country_${this.addressId}`;
    province.id = `address_province_${this.addressId}`;
    container.id = `address_container_${this.addressId}`;

    new Shopify.CountryProvinceSelector(country.id, province.id, {
      hideElement: container.id
    });
  }

  handleRemove(e: Event) {
    e.preventDefault();
    if (confirm("Are you sure you wish to delete this address?")) {
      localStorage.setItem(`removed_address:${this.addressId}`, "true");
      Shopify.postLink(`${this.addressesUrl}/${this.addressId}`, { parameters: { _method: "delete" } });
    }
  }

  toggleOpen(e: Event) {
    e.preventDefault();
    this.isNewAddress() ? this.classList.toggle("hidden") : this.form?.classList.toggle("hidden");
  }
};

customElements.define("address-item", AddressItem);

